import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import RightArrow from "./Assets/Imgs/RightArrow.svg";
import "./style.less";
import BigRectangle from "./Assets/Imgs/bigRectangle.svg";
import triangle from "./Assets/Icons/Triangle.svg";
import MobileRectangle from "./Assets/Imgs/MobileRect.svg";
import { Headline } from "src/Common/Theme/Typography";

import { isDesktop } from "isDesktop";
import { REGIONS } from "src/Services/RegionGetter/Constants";

export const Carousel = ({ slides, header }) => {
  //carousel
  const [current, setCurrent] = useState(1);
  const length = slides.length;

  const nextSlide = useCallback(() => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  });

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  const changeSlide = (id) => {
    setCurrent(id);
  };

  // language + region reducer
  const regionLanguage = useSelector((state) => state.RegionLanguageReducer);
  const { region, language } = regionLanguage;
  const capitalizedRegion = region?.toUpperCase();

  // language + region state
  const [carouselData, setCarouselData] = useState([]);
  const [carouselHeader, setCarouselHeader] = useState("");

  // language + region effect
  useEffect(() => {
    switch (true) {
      case region === REGIONS.vietnam && language === "vn":
        setCarouselData(slides);
        setCarouselHeader(header);
        break;
      default:
    }
  }, [language, region]);

  useEffect(() => {
    //auto slide toggle
    const SecsMS = 8000; //8seconds
    const interval = setInterval(() => {
      if (!isDesktop()) {
        nextSlide();
      }
    }, SecsMS);

    return () => clearInterval(interval);
  }, [nextSlide]);

  return (
    <>
      {/* Desktop */}
      {isDesktop() ? (
        <div className="HomePageCarousel">
          <div className="HomePageCarousel__headStyle">
            <Headline h1 bold shopee>
              {carouselHeader}
            </Headline>
          </div>

          {carouselData.map((slide, index, carouselData) => {
            let next;
            let prev;
            index === length - 1
              ? (next = carouselData[0])
              : (next = carouselData[index + 1]);
            index === 0
              ? (prev = carouselData[length - 1])
              : (prev = carouselData[index - 1]);
            return (
              <div key={index}>
                {index === current && (
                  <div className="HomePageCarousel__grid">
                    <div className="HomePageCarousel__grid__gridItem">
                      <img
                        src={prev.image}
                        alt="slider"
                        className={`HomePageCarousel__carouselPrev__${capitalizedRegion}`}
                      />
                      <img
                        src={triangle}
                        alt="triangle"
                        className="HomePageCarousel__trianglePrev"
                      />
                    </div>
                    <div className="HomePageCarousel__grid__gridItem">
                      <img
                        src={RightArrow}
                        onClick={prevSlide}
                        alt="arrow"
                        className="HomePageCarousel__leftButton"
                      />
                    </div>
                    <div className="HomePageCarousel__grid__gridItem">
                      <img
                        src={BigRectangle}
                        alt="rectangle"
                        className="HomePageCarousel__rectangle"
                      />
                      <img
                        src={triangle}
                        alt="triangle"
                        className="HomePageCarousel__triangle"
                      />
                      <img
                        src={slide.image}
                        alt="slider"
                        className={`HomePageCarousel__sliderImage__${capitalizedRegion}`}
                      />
                      <div className={`HomePageCarousel__userTitle__${capitalizedRegion}`}>
                        <div className={`HomePageCarousel__userTitle__${capitalizedRegion}__userInfo`}>
                          {slide.name}
                          <br />
                          {slide.age}
                          <br />
                          {slide.occupation}
                        </div>
                        <div className={`HomePageCarousel__userTitle__${capitalizedRegion}__userContent`}>
                          <p>{slide.content}</p>
                        </div>
                      </div>
                    </div>
                    <div className="HomePageCarousel__grid__gridItem">
                      <img
                        src={RightArrow}
                        onClick={nextSlide}
                        alt="arrow"
                        className="HomePageCarousel__rightButton"
                      />
                    </div>
                    <div className="HomePageCarousel__grid__gridItem">
                      <img
                        src={BigRectangle}
                        alt="rectangle"
                        className="HomePageCarousel__nextRect"
                      />
                      {/* next */}
                      <div className="HomePageCarousel__userTitleNext">
                        <div className="HomePageCarousel__userTitleNext__userInfo">
                          {next.name}
                          <br />
                          {next.age}
                          <br />
                          {next.occupation}
                        </div>
                        <div className="HomePageCarousel__userTitleNext__userContent">
                          <p>{next.content}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="HomePageCarouselMobile">
          <div className="HomePageCarouselMobile__ContentTitle">
            <Headline h1 bold shopee>
              {carouselHeader}
            </Headline>
          </div>
          <section className="HomePageCarouselMobile__Slider">
            {carouselData.map((slide, index) => {
              return (
                <div key={index}>
                  {index === current && (
                    <div>
                      <img
                        src={MobileRectangle}
                        alt="rectangle"
                        className="HomePageCarouselMobile__Rectangle"
                      />
                      <img
                        src={slide.image}
                        alt="slider"
                        className="HomePageCarouselMobile__SliderImage"
                      />
                      {/* current */}
                      <div className="HomePageCarouselMobile__UserTitle">
                        <div className="HomePageCarouselMobile__UserTitle__UserInfo">
                          <h1 className="HomePageCarouselMobile__UserTitle__TitleTexts">
                            {slide.name}
                            <br />
                            {slide.age}
                            <br />
                            {slide.occupation}
                          </h1>
                        </div>
                        <div className="HomePageCarouselMobile__UserTitle__UserContent">
                          {slide.content}
                        </div>
                      </div>
                      <div className="HomePageCarouselMobile__SlideButtons"
                      >
                        {carouselData.map((slide, index) => {
                          return (
                            <div
                              key={index}
                              onClick={() => changeSlide(index)}
                              className={
                                current === index
                                  ? "HomePageCarouselMobile__SlideButtonCurrent"
                                  : "HomePageCarouselMobile__SlideButton"
                              }
                            ></div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </section>
        </div>
      )}
    </>
  );
};
